// App.js - Entry point switcher
// This file detects the environment and loads the appropriate app.
// - Browser: loads WebApp.js (full web application)
// - Tauri: loads TauriApp.js (desktop application)
//
// DO NOT put application code here. Edit the appropriate file:
// - Web app changes: WebApp.js
// - Desktop app changes: TauriApp.js and components/desktop/

import React, { useState, useEffect } from 'react';
import WebApp from './WebApp';
import TauriApp from './TauriApp';

// Check if running in Tauri (desktop app)
const isTauri = () => {
  return typeof window !== 'undefined' && window.__TAURI_INTERNALS__ !== undefined;
};

function App() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setIsDesktop(isTauri());
    setChecked(true);
  }, []);

  if (!checked) {
    return null;
  }

  return isDesktop ? <TauriApp /> : <WebApp />;
}

export default App;
